/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {deploymentFreshnessSlackMessage} from '../api'

export const useMutationDeploymentFreshnessSlackMessage = createReactQueryMutationHook('deploymentFreshnessSlackMessage', deploymentFreshnessSlackMessage)
